import React from 'react';
import Chart from 'react-apexcharts';
import { PageHeading } from '../../../../../../SharedComponents';
import '../Styles/Styles.scss';

function DonutChart({ data }) {
  const series = data?.map((item) => item?.leadCount);

  const labels = data?.map((item) => item?.sourceName);

  const options = {
    chart: {
      type: 'donut',
    },
    labels: labels,
    legend: {
      position: 'right',
      offsetY: 0,
      labels: {
        colors: ['#000'],
      },
    },
    colors: ['#5E4322', '#6C5129', '#8F6B2F', '#B3956C', '#D2C3A6', '#EDEDED'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 0,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '60%',
        },
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `${val}%`,
      },
    },
  };

  return (
    <div className='chart-card'>
      <PageHeading
        headerTitle={'Lead distribution'}
        headerTitleClasses={'card-title'}
        hasDivider
      />
      <Chart
        options={options}
        series={series}
        type='donut'
        width='100%'
        height='300'
      />
    </div>
  );
}

export default DonutChart;
